export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#E25B26',
    light: '#F6F6F6',
  },
  secondary: {
    main: '#FFFFFF',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#1C1C1C',
    secondary: '#585858',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    link: '#358CD9',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    fill: 'linear-gradient(102.37deg, #03192C 10.33%, #382C29 56.69%)',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#295882',
    footer: '#081E31',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#295882',
    tableSubhead: '#FBFBFB',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E9EDEF80',
    secondary: '#F8D859',
    light: '#FBFBFB',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    border: '#EBEBEB',
  },
  surface: {
    grey: '#F6FBFF',
    savings: '#E1F0FF',
    light: '#F1F7FE',
    learnMore: '#F4F4F4',
    header: '#F1F7FE',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
